let language = {
    500002: "The current coupon code is invalid. Please enter a different one and try again.",
    500001:"The current coupon code has been used once and is now invalid. Please enter a different one and try again.",
    500003:"The current coupon code expired. Please enter another one and try again",
    500005:"The current coupon code expired. Please enter another one and try again"
};

export { language }